import { render, staticRenderFns } from "./BuyCarDialog.vue?vue&type=template&id=1fac865b&scoped=true"
import script from "./BuyCarDialog.vue?vue&type=script&lang=ts"
export * from "./BuyCarDialog.vue?vue&type=script&lang=ts"
import style0 from "./BuyCarDialog.vue?vue&type=style&index=0&id=1fac865b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fac865b",
  null
  
)

export default component.exports